module.exports = __webpack_public_path__ + "static/media/21-10.e3e3505f.mp3";